__turbopack_context__.v({
  "className": "kode_mono_5d321e83-module__eX5U3G__className",
  "variable": "kode_mono_5d321e83-module__eX5U3G__variable",
});
